import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {GroupModel} from "../../../groups/models/group.model";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class branchesMultiSelectListCtrl implements IController {
  selectedIds: any;
  tags?: string[];
  optionIds: any;
  excludeIds: any;
  selectedGroups: GroupModel[] = [];
  hideGroupsFilter: boolean;
  isNoneEnabled?: boolean;
  isNone?: boolean;
  onGroupsFilterChange: Function;
  onChange: Function;
  onChangeFilterNone: Function;

  private branchesRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  private excludeKeys: any;
  public selectedGroupIds: string[];
  public selectedOptionIds: string[];
  public excludedOptionIds: string[];
  public isSelectAll: boolean;
  public subFilterQueryMap: any;
  public includedSubFilters: any[];

  /* @ngInject */
  constructor(private $log, private $branches, private $infiniteScroll, private commonsService: CommonsService) {
  }

  $onInit() {
    this.branchesRef = this.$branches();
    this.loadLimit = 20;

    this.branchesRef.$query(this._getPaginationParams());
    this.infiniteScroll = this.$infiniteScroll(this.branchesRef, this.loadLimit, this._getInfiniteScrollConfig());

    this.subFilterQueryMap = {
      tagType: 'Branch'
    }

    this.includedSubFilters = ['tags'];

    if (!this.hideGroupsFilter) {
      this.includedSubFilters.push('groups');
    }
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })

      this.selectedOptionIds = this.optionIds?.filter(oid => this.selectedIds?.includes(oid));
    }

    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })

      this.excludedOptionIds = [];

      if (!!this.optionIds?.length && this.excludeIds?.length) {
        this.excludedOptionIds = this.optionIds.filter(oid => this.excludeIds.includes(oid));
      }
    }

    if (changes.selectedGroups) {
      this.selectedGroupIds = [];
      if (this.selectedGroups?.length) {
        this.selectedGroupIds = this.selectedGroups.map(g => g.id);
      }
    }

    if (changes.optionIds && !changes.optionIds.isFirstChange()) {
      this.selectedOptionIds = [];
      this.excludedOptionIds = [];
      this.selectedOptionIds = this.optionIds?.filter(oid => this.selectedIds?.includes(oid));
      if (this.excludeIds?.length) {
        this.excludedOptionIds = this.optionIds?.filter(oid => this.excludeIds.includes(oid));
      }
    }

    if (
      (changes.optionIds && !changes.optionIds.isFirstChange()) ||
      (changes.tags && !changes.tags.isFirstChange())
    ) {
      this._reload();
    }
  }


  onToggle(branchId, isSelected) {
    this.onChange({
      branchIds: isSelected ? _.concat(this.selectedIds || [], [branchId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== branchId;
        })
    });
  }

  onToggleSelectAll() {
    if (this.optionIds?.length) {
      const items = this.infiniteScroll.getItems();
      const itemIds = _.map(items, 'id');
      if (itemIds.length === this.selectedOptionIds.length) {
        const selectedOptionToRemove = _.difference(itemIds, this.excludedOptionIds);
        const selectedIds = this.selectedIds.filter(id => !selectedOptionToRemove.includes(id));
        this.onChange({branchIds: selectedIds});
      } else {
        const infiniteScrollLength = this.infiniteScroll.getLength();

        if (infiniteScrollLength < this.optionIds?.length) {
          this.onChange({branchIds: itemIds});
        } else {
          this.onChange({branchIds: _.uniq(this.optionIds.concat(this.selectedIds))})
        }
      }
    } else {
      if (this.isSelectAll) {
        this.onChange({branchIds: []});
      } else {
        this.onChange({branchIds: this.infiniteScroll?.getItems()?.map((branch) => branch.id)});
      }
    }
  }

  onToggleNone() {
    this.onChangeFilterNone({isEnabled: !this.isNone})
  }

  isAllSelected() {
    if (this.optionIds?.length) {
      const items = this.infiniteScroll.getItems();
      this.isSelectAll = this.selectedOptionIds?.length === items.length
    } else {
      this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(branch => branch.id), this.selectedIds);
    }
    return this.isSelectAll;
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.optionIds) {
      this._reload();
    } else {
      this._search();
    }
  }

  // groupsFilterChange(groups) {
  //   this.onGroupsFilterChange({groups: groups})
  // }
  //
  // onChangeBranchTags(tags) {
  //   this.tags = tags;
  //   this._reload();
  // }

  onChangeFilters(tags, groups) {
    this.tags = tags;

    const groupsToAdd = _.difference(this.selectedGroups, groups);
    const groupToRemove = _.difference(groups, this.selectedGroups);

    if (groupsToAdd?.length || groupToRemove?.length) {
      this.onGroupsFilterChange({groups: groups})
    } else {
      this._reload();
    }
  }

  private _reload() {
    this.branchesRef.$query(this._getPaginationParams())
      .then(() => {
        this.infiniteScroll.reload(this._getInfiniteScrollConfig());
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }


  private _search() {
    this.infiniteScroll.search(this.queryString);
  }

  private _getPaginationParams() {
    return {
      limit: this.loadLimit,
      sort: 'name,asc'
    };
  }

  private _getInfiniteScrollConfig() {
    return {
      data: this._getFilterPayload(),
      getFullData: true
    };
  }

  private _getFilterPayload() {
    return {
      query: this.queryString,
      ids: this.optionIds,
      tags: this.tags,
      isInactive: false
    };
  }
}

angular
  .module('bringoz.admin.branches')
  .component('branchesMultiSelectList', {
    bindings: {
      selectedIds: '<',
      tags: '<',
      optionIds: '<?',
      excludeIds: '<?',
      selectedGroups: '<?',
      hideGroupsFilter: '<?',
      isNoneEnabled: '<?',
      isNone: '<?',
      onChange: '&',
      onChangeFilterNone: '&',
      onGroupsFilterChange: '&'
    },
    template: require('./branches-multi-select-list.html').default,
    controller: branchesMultiSelectListCtrl
  });
